import React, { useState, useEffect } from 'react';
import { Globe, Key, Palmtree } from 'lucide-react';
import { LANGUAGES, t } from '../../i18n/languages';
import { useYearStatus } from '../../contexts/YearStatusContext';
import LogoCompany from '../../assets/LogoCompany';

function Header({
  currentUser,
  vacationBalance,
  vacationBalanceForYear,
  onLogout,
  currentLanguage,
  setCurrentLanguage,
  onChangePassword,
  showChangePassword = true,
  currentMonth,
  fetchVacationBalanceForYear
}) {
  // Get year status for dynamic headers
  const { yearStatus } = useYearStatus();
  const [displayYear, setDisplayYear] = useState(new Date().getFullYear());
  const currentYear = new Date().getFullYear();

  // Update display year when currentMonth changes
  useEffect(() => {
    if (currentMonth) {
      const year = currentMonth.getFullYear();
      setDisplayYear(year);
      fetchVacationBalanceForYear(year);
    }
  }, [currentMonth, fetchVacationBalanceForYear]);

  return (
    <div style={{ marginBottom: '32px', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <LogoCompany size={48} color="#FF4757" />
        <h1 style={{ margin: 0, color: '#1f2937', fontSize: '28px', fontWeight: '700' }}>
          {t('appTitle', {}, currentLanguage)}
        </h1>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '16px' }}>
        {/* Language Selector */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Globe size={16} color="#6b7280" />
          <select
            value={currentLanguage}
            onChange={(e) => setCurrentLanguage(e.target.value)}
            style={{
              padding: '4px 8px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '14px',
              backgroundColor: 'white',
              cursor: 'pointer'
            }}
          >
            {Object.values(LANGUAGES).map(lang => (
              <option key={lang.code} value={lang.code}>
                {lang.flag} {lang.name}
              </option>
            ))}
          </select>
        </div>

        {/* Vacation Balance */}
        <div style={{
          padding: '8px 16px',
          backgroundColor: '#f0f9ff',
          border: '1px solid #0ea5e9',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Palmtree size={16} color="#079C0C" />
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#0369a1' }}>
            {(() => {
              const currentOpenYear = yearStatus?.currentOpenYear || currentYear;
              let balanceToUse = displayYear === currentYear + 1 && vacationBalanceForYear ? vacationBalanceForYear : vacationBalance;
              if (!balanceToUse) return `${currentLanguage === 'hr' ? 'Godišnji' : 'Vacation'} (${displayYear}): 0/0`;
              if (currentOpenYear !== currentYear) {
                balanceToUse = vacationBalance
                return `${currentLanguage === 'hr' ? 'Godišnji' : 'Vacation'} (${currentOpenYear}): ${balanceToUse.current_year_remaining}/${balanceToUse.current_year}`;
              }
              return `${currentLanguage === 'hr' ? 'Godišnji' : 'Vacation'} (${displayYear}): ${balanceToUse.current_year_remaining}/${balanceToUse.current_year}`;
            })()}
          </span>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#F58727' }}>
            {(() => {
              const currentOpenYear = yearStatus?.currentOpenYear || currentYear;
              let balanceToUse = displayYear === currentYear + 1 && vacationBalanceForYear ? vacationBalanceForYear : vacationBalance;
              if (!balanceToUse) return `${currentLanguage === 'hr' ? 'Stari' : 'Carryover'} (${displayYear - 1}): 0/0`;
              if (currentOpenYear !== currentYear) {
                balanceToUse = vacationBalance
                return `${currentLanguage === 'hr' ? 'Godišnji' : 'Vacation'} (${currentOpenYear - 1}): ${balanceToUse.carryover_remaining}/${balanceToUse.carryover}`;
              }
              return `${currentLanguage === 'hr' ? 'Godišnji' : 'Vacation'} (${displayYear - 1}): ${balanceToUse.carryover_remaining}/${balanceToUse.carryover}`;
            })()}
          </span>
        </div>
        <div style={{ color: '#6b7280', fontSize: '16px' }}>
          {t('welcome', {}, currentLanguage)}, {currentUser}
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          {onChangePassword && showChangePassword && (
            <button
              onClick={onChangePassword}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                backgroundColor: '#6b7280',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              <Key size={16} />
              {currentLanguage === 'hr' ? 'Promijeni Lozinku' : 'Change Password'}
            </button>
          )}

          {onLogout && (
            <button
              onClick={onLogout}
              style={{
                padding: '8px 16px',
                backgroundColor: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              {t('logout', {}, currentLanguage)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
